import type { BaseItem } from "~/models/Content/BaseItem"
import type { ContentProductPageBlocks } from "~/models/Content/ContentProductPageBlocks"
import type { ContentType } from "~/models/Content/ContentType"
import type { ContentProductPageMediaTypes } from "~/models/Content/ContentProductPageMediaTypes"
import type { Folder } from "~/types/folder"
import type { ContentProductPageUsp } from "~/models/Content/ContentProductPageUsp"
import type { Caption, Video } from "~/types/media"
import type {
  ContentFile,
  MathTaskIbexaSuggestedSolution,
  MathTaskIbexaSuggestedSolutionSection,
  MathTaskIbexa,
  MathTaskIbexaSolution,
} from "~/models/Content/schemas"
import type { PageData, PageSection } from "~/types/pages"
import type { Subject, SubjectPage } from "~/types/subject"
import type { MarketingArticleSectionContent, MarketingArticleContent } from "~/types/MarketingArticle"
import type { Article, Relation } from "~/types/article"
import type { ProductVariants } from "~/models/Content/ContentProducts"
import type { ContentProductPage } from "~/models/Content/ContentProductPage"

// TODO: Would be even better if this was inferrable from valibot schemas, but we are not quite there yet.
interface ContentMap {
  [ContentType.Article]: Article
  [ContentType.ProductPage]: ContentProductPage
  [ContentType.ProductPageUSP]: ContentProductPageUsp
  [ContentType.ProductPageBlock]: ContentProductPageBlocks
  [ContentType.ProductPageMediaTypes]: ContentProductPageMediaTypes
  [ContentType.Folder]: Folder
  [ContentType.Caption]: Caption
  [ContentType.Chapter]: Subject
  [ContentType.ChapterPage]: SubjectPage
  [ContentType.File]: ContentFile
  [ContentType.Page]: PageData
  [ContentType.PageSection]: PageSection
  [ContentType.Video]: Video
  [ContentType.MathTaskIbexa]: MathTaskIbexa
  [ContentType.SolutionIbexa]: MathTaskIbexaSolution
  [ContentType.SuggestedSolutionIbexa]: MathTaskIbexaSuggestedSolution
  [ContentType.SuggestedSolutionSectionIbexa]: MathTaskIbexaSuggestedSolutionSection
  [ContentType.MarketingArticle]: MarketingArticleContent
  [ContentType.MarketingArticleSection]: MarketingArticleSectionContent
  [ContentType.Product]: ProductVariants
  [ContentType.SidenoteWhatIs]: Relation
  [ContentType.SidenoteSource]: Relation
  [ContentType.SidenoteLegalSource]: Relation
  [ContentType.SidenotePerson]: Relation
  [ContentType.SidenoteExplainer]: Relation
  [ContentType.SidenoteTerm]: Relation
  [ContentType.Sidenote]: Relation
}

export type MappedIbexaContent<T extends ContentType> = T extends keyof ContentMap ? ContentMap[T] : never

export function isContentType<T extends ContentType>(...contentTypes: T[]) {
  return (item: BaseItem): item is MappedIbexaContent<T> => contentTypes.includes(item.contentTypeIdentifier as T)
}
